export enum PartnerIdentifierEnum {
    SKYSCANNER = 'skyscanner_redirectid'
}